import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './FaqList.module.css';

// Answers are React nodes so a couple can carry in-line links (pricing, contact).
const FAQS = [
  {
    q: 'What counts as a credit?',
    a: (
      <>One net-new verified lead, email revealed, deliverability-checked, employment confirmed. Nothing else uses credits.</>
    ),
  },
  {
    q: 'So verification and enrichment are free?',
    a: (
      <>
        They're included in your plan under generous monthly allowances (
        <Link className={styles.inlineLink} to="/pricing">see pricing</Link>). Most users
        never hit them. If you do a huge one-off job, RepBuddy tells you before running and
        offers a booster.
      </>
    ),
  },
  {
    q: 'What happens when I run out of credits mid-month?',
    a: (
      <>Nothing breaks. RepBuddy pauses the run, shows you exactly where you stand, and a booster resumes it in one click. Boosters never expire.</>
    ),
  },
  {
    q: 'Do unused credits roll over?',
    a: <>Monthly plan credits reset each cycle. Booster credits never expire.</>,
  },
  {
    q: 'Do I need a work email or credit card to start?',
    a: (
      <>No. You can start your 7-day free trial with any email, no work email and no credit card required.</>
    ),
  },
  {
    q: 'Where does your data come from?',
    a: (
      <>We combine a licensed B2B contact database, live professional-profile verification, real-time email testing, and AI research, then only show you results that pass all checks. Every enriched field shows a confidence tier.</>
    ),
  },
  {
    q: 'Is my data isolated from other customers?',
    a: (
      <>Yes. Every customer's contacts, hunts, and lists are isolated at the database level with row-level security. Your lead lists are never shared with or visible to other customers.</>
    ),
  },
  {
    q: 'Can I cancel anytime?',
    a: <>Yes on monthly. Annual plans run to term (that's what the discount is for).</>,
  },
  {
    q: 'Do you have an API / CRM integration?',
    a: (
      <>
        On the roadmap:{' '}
        <a className={styles.inlineLink} href="mailto:support@repbuddy.io">
          tell us which CRM you need first
        </a>
        .
      </>
    ),
  },
];

function FaqItem({ q, a, index }) {
  const [open, setOpen] = useState(false);
  const panelId = `faq-panel-${index}`;
  const btnId = `faq-btn-${index}`;

  return (
    <div className={`${styles.item} ${open ? styles.itemOpen : ''}`}>
      <h2 className={styles.qHead}>
        <button
          id={btnId}
          className={styles.qBtn}
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((v) => !v)}
        >
          <span>{q}</span>
          <span className={styles.icon} aria-hidden="true" />
        </button>
      </h2>
      {open && (
        <div id={panelId} role="region" aria-labelledby={btnId} className={styles.answer}>
          <p>{a}</p>
        </div>
      )}
    </div>
  );
}

export default function FaqList() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.list}>
          {FAQS.map((f, i) => (
            <FaqItem key={f.q} q={f.q} a={f.a} index={i} />
          ))}
        </div>

        <div className={styles.more}>
          <span className={styles.moreText}>Still have a question?</span>
          <a className={styles.moreLink} href="mailto:support@repbuddy.io">
            support@repbuddy.io
          </a>
        </div>
      </div>
    </section>
  );
}
